export const exploTranslations = {
  // Cashier Report
  L9Ymn7qxXl: {
    closureDateRangeFilter: "dashboards.date-range",
    closureIdFilter: "dashboards.id-de-cloture",
    openClosureOverview: "dashboards.open-closure-overview",
    categoryFilter: "dashboards.categorie",
    activityFilter: "dashboards.activite",
    ticketItemFilter: "dashboards.ticket-item-type",
    priceOptionFilter: "dashboards.price-option",
    salesDetails: "dashboards.sales-details",
    vatReport: "dashboards.rapport-de-tva",
    paymentMethodFilter: "dashboards.payment-method",
    paymentMethodReport: "dashboards.rapport-des-methodes-de-paiement",
    transactionReport: "dashboards.rapport-de-transactions",
    multiCurrencyPaymentReport: "dashboards.multi-currency-payment-report",
    sellerIdColumn: "dashboards.seller-id",
    seller: "dashboards.vendeur",
    openingDateTime: "dashboards.date-heur-ed-ouverture",
    closingDateTime: "dashboards.date-heur-ed-efermeture",
    pivotAccountingCode: "dashboards.code-comptable",
    pivotProduct: "dashboards.product",
    pivotTicketItem: "dashboards.ticket-hyphen-item",
    pivotPriceOption: "dashboards.price-hyphen-option",
    pivotVatCode: "dashboards.code-tva",
    pivotVatRate: "dashboards.taux-de-tva",
    pivotQuantitySold: "dashboards.quantite-vendue",
    pivottotalExclVat: "dashboards.total-ht",
    pivotVatAmount: "dashboards.montant-tva",
    pivotTotalPrice: "dashboards.total-ttc",
    pivotDiscountAmount: "dashboards.discount-amount",
    pivotVat: "dashboards.tva",
    pivotPaymentGateWay: "dashboards.passerelle-de-paiement",
    pivotPayentMethod: "dashboards.payment-method",
    pivotNbrTransactions: "dashboards.nombre-de-transactions",
    pivotPaymentValue: "dashboards.payment-value",
    pivotRefundValue: "dashboards.refund-value",
    pivotPaymentRefundValue: "dashboards.payment-refund-value",
    pivotTransactionDate: "dashboards.date-de-transaction",
    pivotCustomerFirstName: "dashboards.customer-first-name",
    pivotCustomerLastName: "dashboards.customer-last-name",
    pivotCusotmerEmail: "dashboards.customer-email",
    pivotExchangeRate: "dashboards.exchange-rate",
    pivotTotal: "dashboards.total",
    pivotRounDiff: "dashboards.rounding-difference",
    pivotTotalInMainCurrency: "dashboards.total-main-currency",
  },
  //POS statistics
  aXxpbyRAqP: {
    dateRangeFilter: "dashboards.date-range",
    share: "dashboards.share",
    productFilter: "dashboards.product",
    ticketItemFilter: "dashboards.ticket-item-type",
    applyFilterButton: "dashboards.apply-filters",
    posStatistics: "dashboards.pos-statistics",
    sales: "dashboards.vente",
    salesTicketsDesc: "dashboards.gross-sales-after-discounts",
    numberOfCheckedInVisitors: "dashboards.number-checked-in-visitors",
    remainingVisitorsToCheckIn: "dashboards.remaining-visitors-check-in",
    numberOfCheckedInVisitorsDesc: "dashboards.daily-tickets-only",
    salesTickets: "dashboards.sales-tickets",
    numberOfItemSoldTickets: "dashboards.number-items-sold-tickets",
    avgNumberOfItemsPerBasketTickets:
      "dashboards.average-number-items-per-basket-tickets",
    noShowRate: "dashboards.no-show-rate",
    salesRetail: "dashboards.sales-retail",
    numberOfItemsoldRetail: "dashboards.number-items-sold-retail",
    avgNumberOfItemsPerBasketRetail:
      "dashboards.avg-number-items-per-basket-retail",
    visitorWalkIn: "dashboards.visitor-walk-in-vs-reservation-rate",
    visitorReservationRate: "dashboards.visitor-reservation-rate",
    visitorWalkInRate: "dashboards.visitor-walk-in-rate",
    avgValuePerBasketBVD: "dashboards.avg-value-per-basket-booking-visit-date",
    numberOfItemsSoldRetailRD:
      "dashboards.number-items-sold-retail-recognition-date",
    numberOfItemsSoldTicketRD:
      "dashboards.number-items-sold-tickets-recognition-date",
    salesRD: "dashboards.sales-recognition-date-brackets",
    salesRetailRD: "dashboards.sales-retail-recognition-date",
    salesTicketRD: "dashboards.sales-tickets-recognition-date",
  },
};
